import { DASHBOARD_PIE_FILTER_TYPES, PERSON_TYPES, ORDER_STATUS_TYPES, ORDER_STATUS_TYPES_MAP } from './constants.js';

export const ceremonyThemeOptions = [
  { value: '追思会', label: '追思会' },
  { value: '告别会', label: '告别会' },
];

export const genderOptions = [
  { value: 0, label: '男' },
  { value: 1, label: '女' },
];

export const useInCeremonyOptions = [
  { value: true, label: '使用' },
  { value: false, label: '不使用' },
];

export const firstOrThirdPersonOptions = [
  { value: PERSON_TYPES.THIRD_PERSON, label: PERSON_TYPES.THIRD_PERSON },
  { value: PERSON_TYPES.FIRST_PERSON, label: PERSON_TYPES.FIRST_PERSON },
];

export const flowTypesOptions = [
  { value: '2', label: '标准 - 文案、图转视频、声音' },
  { value: '1', label: '声音 - 文案、声音' },
];

export const adminOrderStatusOptions = [
  { value: String(ORDER_STATUS_TYPES.未提交), label: ORDER_STATUS_TYPES_MAP[ORDER_STATUS_TYPES.未提交] },
  { value: String(ORDER_STATUS_TYPES.文案确认中), label: ORDER_STATUS_TYPES_MAP[ORDER_STATUS_TYPES.文案确认中] },
  { value: String(ORDER_STATUS_TYPES.审核中), label: ORDER_STATUS_TYPES_MAP[ORDER_STATUS_TYPES.审核中] },
  { value: String(ORDER_STATUS_TYPES.资料修改中), label: ORDER_STATUS_TYPES_MAP[ORDER_STATUS_TYPES.资料修改中] },
  { value: String(ORDER_STATUS_TYPES.工作流待开始), label: ORDER_STATUS_TYPES_MAP[ORDER_STATUS_TYPES.工作流待开始] },
  { value: String(ORDER_STATUS_TYPES.工作流进行中), label: ORDER_STATUS_TYPES_MAP[ORDER_STATUS_TYPES.工作流进行中] },
  { value: String(ORDER_STATUS_TYPES.工作流已完成), label: ORDER_STATUS_TYPES_MAP[ORDER_STATUS_TYPES.工作流已完成] },
  { value: String(ORDER_STATUS_TYPES.工作流失败), label: ORDER_STATUS_TYPES_MAP[ORDER_STATUS_TYPES.工作流失败] },
  { value: String(ORDER_STATUS_TYPES.已完成), label: ORDER_STATUS_TYPES_MAP[ORDER_STATUS_TYPES.已完成] },
];

export const companyOrderStatusOptions = [
  { value: String(ORDER_STATUS_TYPES.未提交), label: ORDER_STATUS_TYPES_MAP[ORDER_STATUS_TYPES.未提交] },
  { value: String(ORDER_STATUS_TYPES.文案确认中), label: ORDER_STATUS_TYPES_MAP[ORDER_STATUS_TYPES.文案确认中] },
  { value: String(ORDER_STATUS_TYPES.审核中), label: ORDER_STATUS_TYPES_MAP[ORDER_STATUS_TYPES.审核中] },
  { value: String(ORDER_STATUS_TYPES.资料修改中), label: ORDER_STATUS_TYPES_MAP[ORDER_STATUS_TYPES.资料修改中] },
  { value: String(ORDER_STATUS_TYPES.视频制作中), label: ORDER_STATUS_TYPES_MAP[ORDER_STATUS_TYPES.视频制作中] },
  { value: String(ORDER_STATUS_TYPES.已完成), label: ORDER_STATUS_TYPES_MAP[ORDER_STATUS_TYPES.已完成] },
];

export const staffOrderStatusOptions = [
  { value: String(ORDER_STATUS_TYPES.视频制作中), label: ORDER_STATUS_TYPES_MAP[ORDER_STATUS_TYPES.视频制作中] },
  { value: String(ORDER_STATUS_TYPES.已完成), label: ORDER_STATUS_TYPES_MAP[ORDER_STATUS_TYPES.已完成] },
];

export const audioSpeedOptions = [
  { value: '0.5', label: '0.5' },
  { value: '0.6', label: '0.6' },
  { value: '0.7', label: '0.7' },
  { value: '0.8', label: '0.8' },
  { value: '0.9', label: '0.9' },
  { value: '1', label: '1' },
];

export const dashboardTimeFilterOptions = [
  { value: '累计', label: '累计' },
  { value: '本月', label: '本月' },
  { value: '本年', label: '本年' },
  { value: '自定义', label: '自定义' },
];

export const dashboardTrendFilterOptions = [
  { value: '订单套餐', label: '订单套餐分类' },
  { value: '订单状态', label: '订单状态数据' },
  { value: '订单收入', label: '营收数据' },
];

export const dashboardPieFilterOptions = [
  {
    value: DASHBOARD_PIE_FILTER_TYPES.ORDER,
    label: DASHBOARD_PIE_FILTER_TYPES.ORDER,
  },
  {
    value: DASHBOARD_PIE_FILTER_TYPES.REVENUE,
    label: DASHBOARD_PIE_FILTER_TYPES.REVENUE,
  },
];
